import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18433ef4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-panel-module__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
			'hd-panel-module',
			`hd-panel-module__${_ctx.modifier}`,
		])
  }, [
    _createElementVNode("div", {
      class: "hd-panel-module__close-wrapper",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.processPanel()))
    }),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ], 2))
}